import type { CSSProperties } from 'react';
import styles from './SkeletonBox.module.css';

interface SkeletonBoxProps {
	width?: string;
	height?: string;
	borderRadius?: string;
	style?: CSSProperties;
}

export const SkeletonBox = ({ width, height, borderRadius = '0.25rem', style }: SkeletonBoxProps) => (
	<div className={styles.shimmer} style={{ width, height, borderRadius, ...style }} />
);
